import React, { useState } from 'react';

import { openPopup } from 'helpers/index';
import { SmallLoader } from 'components/Loader';
import PrinterIcon from 'images/zappos/printer-link-icon.svg';

import css from 'styles/components/account/returns/returnConfirmationCode.scss';

const ReturnConfirmationCode = ({ email, qrcodeUrl, returnLabelUrl, rmaId }) => {
  const [qrcodeLoaded, setQrcodeLoaded] = useState(false);

  return (
    <div className={css.container}>
      <h3>Your Return Code</h3>
      <div className={css.content}>
        <div className={css.qrCodeWrapper}>
          <div className={css.qrCode}>
            {!qrcodeLoaded && <SmallLoader />}
            <img hidden={!qrcodeLoaded} onLoad={() => setQrcodeLoaded(true)} src={qrcodeUrl} alt="QR Code" />
          </div>
          <span className={css.printButton}>
            Optional: &nbsp;
            <a href={`${returnLabelUrl}?rmaId=${rmaId}&displayInfo=true`} onClick={openPopup} data-popup-options="width=1000,height=800">
              <span className={css.printButtonIcon}>
                <img src={PrinterIcon} alt="printerIcon" /> Print
              </span>
            </a>
          </span>
        </div>

        {email && (
          <div className={css.labelDescription}>
            <span>Return code will also be sent to: </span>
            {email}
          </div>
        )}
      </div>
    </div>
  );
};

export default ReturnConfirmationCode;
